import { ReactNode } from 'react';
import styled, { keyframes } from 'styled-components';

const ORANGE = '#F99746';
const INK = '#1A1F18';
const EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

const dotBounce = keyframes`
  0%, 80%, 100% { transform: translateY(0);   opacity: 0.4; }
  40%          { transform: translateY(-8px); opacity: 1;   }
`;

type Props = {
  /** Optional text shown above the dots. Omit to render the dots alone. */
  label?: ReactNode;
  /** Forwarded so consumers can add layout (e.g. `flex: 1`) via styled(). */
  className?: string;
};

const AnticipationLoader = ({ label, className }: Props) => (
  <Container className={className} aria-live="polite">
    {label != null && <Label>{label}</Label>}
    <Dots aria-hidden="true">
      <Dot $delayMs={0} />
      <Dot $delayMs={180} />
      <Dot $delayMs={360} />
    </Dots>
  </Container>
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: clamp(12px, 2vh, 28px);
`;

const Label = styled.span`
  font-size: clamp(24px, 4vh, 56px);
  font-weight: 900;
  letter-spacing: -0.01em;
  text-transform: lowercase;
  color: ${INK};
  opacity: 0.85;
`;

const Dots = styled.span`
  display: inline-flex;
  align-items: center;
  gap: clamp(6px, 1vh, 12px);
`;

const Dot = styled.span<{ $delayMs: number }>`
  width: clamp(10px, 1.4vh, 18px);
  height: clamp(10px, 1.4vh, 18px);
  border-radius: 50%;
  background: ${ORANGE};
  animation: ${dotBounce} 1.4s ${EASE} infinite;
  animation-delay: ${({ $delayMs }) => $delayMs}ms;
`;

export default AnticipationLoader;
